import React from 'react';

import { filterSingleBy, simpleColumn } from '../../utils/column-helpers';
import { createdBy, modified } from '../../utils/columns';
import { ContactListLink } from './Link';

const nameLink = {
  ...simpleColumn('Name', 'name'),
  Cell: row => <ContactListLink model={row.original} />,
};

const description = simpleColumn('Description', 'description');

const count = {
  ...simpleColumn('Number of contacts', 'contactIds'),
  Cell: ({ value = [] }) => value.length,
  filterMethod: (filter, { contactIds = [] }) =>
    filterSingleBy(filter, String(contactIds.length)),
};

const contactListColumns = [nameLink, description, count, createdBy, modified];
export default contactListColumns;
